import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { MetricWidgetLineGraphContainer } from "../../../common/widget/line-graph/MetricWidgetLineGraphContainer";
import { useSocialMediaMetricsOverTimeData } from "../../hooks/useSocialMediaMetricsOverTimeData";

import { useTabs } from "./useTabs";

export const SocialMediaMetricsOverTime = () => {
    const { translate } = useTranslate();
    const { selectedDataType, tabs, tabIndex, onSelect } = useTabs();

    const { data, primaryDomain, isMonthly, isLoading, isError } = useSocialMediaMetricsOverTimeData();

    const graphData = useMemo(
        () =>
            data.map(({ domain, series, totalVolume }) => ({
                id: domain,
                name:
                    domain === primaryDomain ? translate("activation.common.your-domain", { domain }) : domain,
                data: series[selectedDataType],
                total: totalVolume[selectedDataType],
            })),
        [data, primaryDomain, selectedDataType, translate],
    );

    const legendHeaders = useMemo(
        () => [
            translate("common.domain"),
            translate("activation.alerts.social.metrics.metrics-over-time-widget.legend-header.total-volume"),
        ],
        [translate],
    );

    return (
        <MetricWidgetLineGraphContainer
            automationId="social-media-metrics-over-time-widget"
            data={graphData}
            isError={isError}
            isLoading={isLoading}
            isMonthly={isMonthly}
            legendHeaders={legendHeaders}
            onTabSelect={onSelect}
            selectedTabIndex={tabIndex}
            tabs={tabs}
            title={translate("activation.alerts.social.metrics.metrics-over-time-widget.title")}
        />
    );
};
